import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './TestimonialsSection.css'; // Archivo CSS para estilos personalizados

const TestimonialsSection = () => {
  return (
    <section className="testimonials-section py-5">
      <Container>
        <h2 className="text-center mb-4">Únete a nuestra comunidad de estudiantes exitosos</h2>
        <Row className="text-center">
          <Col md={6} lg={3}>
            <Card className="testimonial-card mb-4">
              <Card.Body>
                <blockquote className="blockquote">
                  <p>La mejor profesora Ailen!! Me dio la confianza para aprender y dar al IELTS de la mejor forma. Logré el puntaje que quería y sin duda Ailen es la responsable de este resultado.</p>
                </blockquote>
                <div className="testimonial-author d-flex align-items-center">
                  <img src="https://randomuser.me/api/portraits/men/1.jpg" alt="Ignacio" className="rounded-circle me-2" width="40" />
                  <div>
                    <strong>Ignacio</strong>
                    <div>★★★★★</div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col md={6} lg={3}>
            <Card className="testimonial-card mb-4">
              <Card.Body>
                <blockquote className="blockquote">
                  <p>Excelente profesora, maneja muchas herramientas interactivas, por lo que hace las clases muy divertidas, es amable y muy aplicada, totalmente recomendada.</p>
                </blockquote>
                <div className="testimonial-author d-flex align-items-center">
                  <img src="https://randomuser.me/api/portraits/men/2.jpg" alt="Cristobal" className="rounded-circle me-2" width="40" />
                  <div>
                    <strong>Cristobal</strong>
                    <div>★★★★★</div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col md={6} lg={3}>
            <Card className="testimonial-card mb-4">
              <Card.Body>
                <blockquote className="blockquote">
                  <p>Ailen es una excelente profesora, con mucha paciencia, siempre dispuesta a resolver dudas del alumno y con variedad de herramientas para el aprendizaje.</p>
                </blockquote>
                <div className="testimonial-author d-flex align-items-center">
                  <img src="https://randomuser.me/api/portraits/men/3.jpg" alt="Joaquin" className="rounded-circle me-2" width="40" />
                  <div>
                    <strong>Joaquin</strong>
                    <div>★★★★★</div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col md={6} lg={3}>
            <Card className="testimonial-card mb-4">
              <Card.Body>
                <blockquote className="blockquote">
                  <p>Thank you teacher! I wish you the best of luck. Hope to see you soon!</p>
                </blockquote>
                <div className="testimonial-author d-flex align-items-center">
                  <img src="https://randomuser.me/api/portraits/women/3.jpg" alt="Marcela" className="rounded-circle me-2" width="40" />
                  <div>
                    <strong>Marcela</strong>
                    <div>★★★★★</div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default TestimonialsSection;
